import React from 'react';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { EuiLink, EuiText } from '@elastic/eui';
import { TranslateLanguage } from './KeywordTranslator';

const EVEREST_SOURCE_URL = 'https://www.everestaudiobible.org/mp3-download';

export default function EverestAudioAttribution({ language }) {
  const openSource = async event => {
    event.preventDefault();
    event.stopPropagation();

    if (Capacitor.isNativePlatform()) {
      await Browser.open({ url: EVEREST_SOURCE_URL });
      return;
    }

    const sourceWindow = window.open(EVEREST_SOURCE_URL, '_blank');
    if (sourceWindow) sourceWindow.opener = null;
  };

  return (
    <EuiText size="xs" color="subdued">
      <p>
        {TranslateLanguage(language, '音頻由 Everest Audio Bible 網站提供。')}{' '}
        <EuiLink
          href={EVEREST_SOURCE_URL}
          target="_blank"
          rel="noreferrer"
          onClick={openSource}
        >
          {TranslateLanguage(language, '查看來源')}
        </EuiLink>
      </p>
    </EuiText>
  );
}
